import { Perspective, type PerspectiveMatrix } from "./Perspective";
import type { ReversePixelMapperFactory } from "../../ReversePixelMapperFactory";

/**
 * Creates PerspectiveProjection distortion.
 *
 * @see https://imagemagick.org/api/MagickCore/distort_8c_source.html#l00853 Generating inverted perspective distortion
 * matrix from forward perspective matrix at ImageMagick source.
 */
export class PerspectiveProjectionFactory
  implements ReversePixelMapperFactory<PerspectiveMatrix>
{
  /**
   * Creates perspective distortion using perspective matrix.
   *
   * @param args Perspective matrix.
   */
  create(args: PerspectiveMatrix): Perspective {
    return Perspective.fromForwardMatrix(args);
  }
}
